import script from "./ItemsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ItemsTable.vue?vue&type=script&lang=ts&setup=true"

import "./ItemsTable.vue?vue&type=style&index=0&id=121072fc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-121072fc"]])

export default __exports__